import type { FC } from "react";

export const MessageTypingIndicator: FC = () => (
  <div className="flex h-6 items-center space-x-1">
    <div className="h-2 w-2 animate-pulse rounded-full bg-gray-400"></div>
    <div className="h-2 w-2 animate-pulse rounded-full bg-gray-400 delay-75"></div>
    <div className="h-2 w-2 animate-pulse rounded-full bg-gray-400 delay-150"></div>
  </div>
);
